import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SessionExpiredDialogProps {
  open: boolean;
  onClose: () => void;
}

export const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="session-expired-dialog-title"
      aria-describedby="session-expired-dialog-description"
    >
      <DialogTitle id="session-expired-dialog-title">
        {t('error.sessionTimeout.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="session-expired-dialog-description">
          {t('error.sessionTimeout.message')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          {t('error.sessionTimeout.button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};